// Animation keyframes and utilities for the application
import { keyframes } from '@mui/material/styles';

// Fade in animation
export const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

// Slide up animation
export const slideUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

// Slide in from left
export const slideInLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

// Slide in from right
export const slideInRight = keyframes`
  from {
    opacity: 0;
    transform: translateX(30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

// Scale in animation
export const scaleIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

// Pulse animation (for important elements)
export const pulse = keyframes`
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
`;

// Shimmer effect (for loading states)
export const shimmer = keyframes`
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
`;

// Glow animation for energy-related elements
export const glow = keyframes`
  0%, 100% {
    box-shadow: 0 0 5px rgba(29, 56, 141, 0.3), 0 0 10px rgba(29, 56, 141, 0.2);
  }
  50% {
    box-shadow: 0 0 10px rgba(29, 56, 141, 0.5), 0 0 20px rgba(29, 56, 141, 0.3), 0 0 30px rgba(29, 56, 141, 0.2);
  }
`;

// Rotate animation (for loading spinners)
export const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

// Float animation (subtle movement)
export const float = keyframes`
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
`;

// Energy flow animation
export const energyFlow = keyframes`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`;

// Export animation utilities
export const animations = {
  fadeIn: `${fadeIn} 0.4s ease-out`,
  slideUp: `${slideUp} 0.5s ease-out`,
  slideInLeft: `${slideInLeft} 0.5s ease-out`,
  slideInRight: `${slideInRight} 0.5s ease-out`,
  scaleIn: `${scaleIn} 0.3s ease-out`,
  pulse: `${pulse} 2s ease-in-out infinite`,
  shimmer: `${shimmer} 2s linear infinite`,
  glow: `${glow} 3s ease-in-out infinite`,
  rotate: `${rotate} 1s linear infinite`,
  float: `${float} 3s ease-in-out infinite`,
  energyFlow: `${energyFlow} 3s ease infinite`,
};

// Transition utilities
export const transitions = {
  default: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  fast: 'all 0.15s cubic-bezier(0.4, 0, 0.2, 1)',
  slow: 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
  spring: 'all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
};

// Stagger animation delay helper
export const getStaggerDelay = (index: number, baseDelay: number = 0.1): string => {
  return `${index * baseDelay}s`;
};

